module.exports = __webpack_public_path__ + "img/zixue_renyuan.edf1df7a.png";